export default __webpack_public_path__ + "static/media/rs.3e516456.svg";